import { useTranslation } from "react-i18next";
import { Button } from "@/shared/ui/Button";
import { HStack } from "@/shared/ui/Stack";
import styles from "./ImageExportWindow.module.css";
import type { ImageExportControlsProps } from "./types";

export function ImageExportControls({
    format,
    isExporting,
    onDownload,
    onClose,
}: ImageExportControlsProps) {
    const { t } = useTranslation();
    const formatLabel = format.toUpperCase();

    return (
        <HStack gap={8} className={styles.controls} data-ui-root>
            <Button disabled={isExporting} onClick={onDownload}>
                {isExporting
                    ? `${t("export.exporting")}...`
                    : `${t("export.download")} ${formatLabel}`}
            </Button>

            <Button variant="tertriary" disabled={isExporting} onClick={onClose}>
                {t("common.close")}
            </Button>
        </HStack>
    );
}
